import ResetCard from './Reset';

export default ResetCard;
